(function($) {
    "use strict";

	jQuery(document).ready(function(){

	
      
      /* Match Heigh   
      $('.item').matchHeight();
      */
		
    /*----------------------------
       stickey menu
    ----------------------------*/
        $(window).on('scroll',function() {    
               var scroll = $(window).scrollTop();
               if (scroll < 165) {
                $(".sticky-header").removeClass("sticky");
               }else{
                $(".sticky-header").addClass("sticky");
               }
        });

        /*----------------------------
        jQuery MeanMenu
        ------------------------------ */
        $('.mobile-menu nav').meanmenu({
            meanScreenWidth: "9901",
            meanMenuContainer: ".mobile-menu",
            onePage: true,
        });

       
        
        $('.shop-product_list').owlCarousel({
            loop: true,
            nav: false,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 5,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:true
                },
                768:{
                    items:2,
                    nav:false
                },	
                992:{
                    items:3,
                    nav:false
                },

                1300:{
                    items:4,
                    nav:true,
                    loop:false
                },
                1600:{
                    items:5,
                    nav:true,
                    loop:false
                }

              }
        });

        $('.best_selling_product_list').owlCarousel({
            loop: true,
            nav: false,
            autoplay: false,
          	
            rtl: true, 
          	
          	autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 5,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                575:{
                    items:2,
                    nav:true
                },
                768:{
                    items:2,
                    nav:false
                },
                992:{
                    items:3,
                    nav:false
                },
                1500:{
                    items:4,
                    nav:true,
                    loop:false
                }
              }
        });   

        $('.brand_list_carousel').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
            
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 5,
             responsiveClass:true,
            responsive:{
                320:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:true
                },
                768:{
                    items:3,
                    nav:false
                },
                991:{
                    items:4,
                    nav:false
                },	
                1200:{
                    items:5,
                    nav:false
                },

              }
        });
        $('.features_product_three_active').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 4,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:true
                },
                768:{
                    items:3,
                    nav:false
                },	
                992:{
                    items:3,
                    nav:false
                },
                1200:{
                    items:4,
                    nav:true,
                    loop:false
                },
              }
        });

        $('.features_product_four_active').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 4,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:true
                },
                768:{
                    items:2,
                    nav:false
                },	
                992:{
                    items:3,
                    nav:false
                },
                1200:{
                    items:4,
                    nav:true,
                    loop:false
                },


              }
        });
        $('.pos_special_active').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i> prev','next <i class="fa fa-angle-right"></i>'],
            items: 1,
        });
        $('.features_product_active_three').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 5,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:true
                },
                768:{
                    items:3,
                    nav:false
                },	
                992:{
                    items:4,
                    nav:false
                },
                1200:{
                    items:5,
                    nav:true,
                    loop:false
                },


              }
        });

        $('.features_product_active_four').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 5,
            responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:true
                },
                768:{
                    items:3,
                    nav:false
                },	
                992:{
                    items:4,
                    nav:false
                },
                1200:{
                    items:5,
                    nav:true,
                    loop:false
                },


              }
        });

        $('.best_selling_product_three').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 1,
             responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:1,
                    nav:false
                },	
                992:{
                    items:1,
                    nav:false
                },

              }
        }); 

        $('.related_product_active').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
            autoplayTimeout: 5000,
          	
            rtl: true, 
          	
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 4,
             responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:false
                },
                768:{
                    items:3,
                    nav:false
                },	
                992:{
                    items:4,
                    nav:false
                },

              }
        }); 
      
        $('#ProductThumbs').owlCarousel({
            loop: true,
            nav: true,
            autoplay: false,
          	
            rtl: true, 
          	
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 4,
             responsiveClass:true,
            responsive:{
                0:{
                    items:1,
                    nav:true
                },
                480:{
                    items:2,
                    nav:false
                },
                768:{
                    items:3,
                    nav:false
                },	
                992:{
                    items:4,
                    nav:false
                },

              }
        });

        $('.product_nav_active').owlCarousel({
            loop: true,
            nav: true,
          	
            rtl: true, 
          	
            autoplay: false,
            autoplayTimeout: 5000,
            navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
            items: 3,
        });

        $('.testimonial___wrapper').owlCarousel({
            loop: true,
            nav: true,
          	
            rtl: true, 
          	
            items: 1,
            autoplay: true,
        });
      

        /*--------------------------
         ScrollUp
        ---------------------------- */
        $.scrollUp({
            scrollText: '<i class="fa fa-angle-double-up"></i>',
            easingType: 'linear',
            scrollSpeed: 900,
            animation: 'fade'
        });

        /*header_account slideToggle*/

        $(".account_inner > a").on("click", function() {
          	  $(this).removeAttr('href');
               $('.content-setting-dropdown').slideToggle('medium');
        }); 

        /*countdown activation*/

         $('[data-countdown]').each(function() {
            var $this = $(this), finalDate = $(this).data('countdown');
            $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<div class="countdown_area"><div class="single_coutdown"><div class="content-number">%D</div><div class="content-title">Day</div></div><div class="single_coutdown"><div class="content-number">%H</div><div class="content-title">Hr</div></div><div class="single_coutdown"><div class="content-number">%M</div><div class="content-title">Min</div></div><div class="single_coutdown"><div class="content-number">%S</div><div class="content-title">Sec</div></div></div>'));
        });
        });	

     
    
        /*----------------------------
            slider-range here
        ------------------------------ */
        $( "#slider-range" ).slider({
          range: true,
          min: 0,
          max: 500,
          values: [ 75, 300 ],
          slide: function( event, ui ) {
            $( "#amount" ).val( "$" + ui.values[ 0 ] + " - $" + ui.values[ 1 ] );
          }
        });
        $( "#amount" ).val( "$" + $( "#slider-range" ).slider( "values", 0 ) +
          " - $" + $( "#slider-range" ).slider( "values", 1 ) );
        /*------------------------
            video popup here
         -----------------------*/

        $('.video__trigger').magnificPopup({
          type: 'iframe',
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          zoom: {
              enabled: true,
          }
        });

        /*------------------------------
          Category menu Activation
        ------------------------------*/
        $(".button_categories h4 > a").on("click", function() {
          	$(this).removeAttr('href');
            $('.categories_menu').slideToggle();
        });
      	
       	$( ".categories_menu ul li:gt(9)" ).addClass( "hide_item" );
      	$( ".categories_menu ul li:nth-child(10)").addClass( "cat_sub" );
        $(".categories_menu ul li.cat_sub a").on("click", function() {
          	$(this).removeAttr('href');
            $(this).toggleClass('open');
            $('.hide_item').slideToggle('medium');
        }); 




	 /*============= Setting Option ==============*/



        $('.dropdown-toggle').on('click', function () {

          $(this).siblings('.switcher-dropdown').toggleClass('is-visible');

        });
   
		$(".cart.cart-disable").removeAttr('href');
      
    
      
      
      
    });

})(jQuery);



